import * as React from 'react';
import { SVGProps } from 'react';

const SvgPinterest = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.299 19.632a8.093 8.093 0 0 0 2.368.368 8 8 0 1 0-7.999-7.999c0 3.4 2.136 6.32 5.152 7.472-.072-.624-.144-1.656 0-2.368l.92-3.952s-.232-.464-.232-1.2c0-1.104.688-1.928 1.472-1.928.688 0 1.008.504 1.008 1.152 0 .688-.456 1.672-.688 2.616-.136.784.416 1.472 1.216 1.472 1.424 0 2.528-1.52 2.528-3.664 0-1.92-1.376-3.232-3.352-3.232-2.256 0-3.584 1.68-3.584 3.448 0 .688.224 1.384.592 1.84.072.048.072.112.048.232l-.232.872c0 .136-.088.184-.224.088-1.024-.448-1.616-1.904-1.616-3.08 0-2.528 1.792-4.824 5.248-4.824 2.752 0 4.896 1.976 4.896 4.6 0 2.752-1.704 4.96-4.144 4.96-.776 0-1.536-.416-1.808-.904l-.536 1.896c-.184.688-.688 1.608-1.032 2.16v-.024z" />
  </svg>
);

export default SvgPinterest;
